import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Switch.module.css'

const Switch = ({ onChange, disabled, checked, id, testId }) => (
  <label htmlFor={id} className={styles.switch}>
    <input
      type="checkbox"
      id={id}
      disabled={disabled}
      onChange={onChange}
      checked={checked}
      data-testid={testId}
    />
    <span
      className={classNames(styles.slider, styles.round, {
        [styles.disabled]: disabled,
      })}
    />
  </label>
)

Switch.propTypes = {
  id: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  testId: PropTypes.string,
}

Switch.defaultProps = {
  id: 'switch',
  onChange: () => {},
  disabled: false,
  checked: false,
  testId: undefined,
}

export default Switch
